var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app"}},[_c('main',{staticClass:"flex-fill"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }